/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetFeatureFlagsRequest} from '@cash-web/protos/squareup/franklin/app/feature_flags.pb'
import {GetFeatureFlagsResponse} from '@cash-web/protos/squareup/franklin/app/feature_flags.pb'


export const getFeatureFlagsSemaphore = (request: GetFeatureFlagsRequest, options?: CashRequestOptions) => post<GetFeatureFlagsRequest, GetFeatureFlagsResponse>("/2.0/cash/get-feature-flags-semaphore", request, {...options, rejectOnError: true })